import React from 'react';
import { Link } from 'react-router-dom';
import { Img } from "react-image";
import User from '../../../models/User';
import LoadingSpinner from '../../../components/LoadingSpinner';
import UserImageCircle from '../../../components/UserImageCircle';

const TeamMemberCard = ({ member, teamId, discipline,disabled, linkParams = {} }) => {
    const user = member ? User.make({ ...member }) : null;
    return (
        <div className="team-member-panel w-full">
            <div className="top-panel">

                {user ? (
                    <div
                        className={TB.mapClass("text-decoration-none m-auto text-center", {
                            'no-click': disabled
                        })}
                    >
                        <div className="profile-image-container">
                            <Img
                                loader={(
                                    <div
                                        className="self-stretch justify-center items-center flex flex-col">
                                        <LoadingSpinner />
                                    </div>
                                )}
                                unloader={<UserImageCircle user={user} hideTooltip={true} size={80} />}
                                src={user.image_path}
                                className="img-grayscale profile-image m-auto" />
                        </div>
                        <p className="member-user-name text-center pb-1">
                            {user.firstNamePlusInitial()}
                        </p>
                        <div className="member-user-title text-center pb-1">
                            {user.disciplines.map(discipline => (
                                <p key={discipline.id} className="bg-wripplePrimaryPaleGreen rounded-full px-2 inline-block">{discipline.name}</p>
                            ))}
                        </div>

                        {user.email && (
                            <p className="member-user-title text-center">
                                {user.email}
                            </p>
                        )}

                        <Link
                            to={`/team-profiles/${teamId}/talent-profiles/${member.id}`}
                            state={{ linkParams }}
                            target="_blank"
                            className="btn-link-primary pt-1 inline-block text-xs"
                        >
                            View Profile
                        </Link>
                    </div>
                ) : (
                    <div className="text-decoration-none">
                        <div>
                            <div className="flex items-center justify-center m-auto profile-image">
                                <i className="fa fa-user text-center text-muted"
                                    style={{ fontSize: 50 }} />
                            </div>
                        </div>

                        <p className="member-user-name">
                            {discipline?.name || "Unassigned"}
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TeamMemberCard;